/**
 * Sentry browser (Clinical + Care web en el mismo bundle Vite).
 * Equivalente a sentry.client.config.ts de Next.js App Router.
 */
import * as Sentry from '@sentry/react';
import {
  getSentryDsn,
  getSentryEnvironment,
  getSentryRelease,
  isProductionLikeEnv,
  isSentryEnabled,
} from './src/lib/observability/sentry-env';
import { scrubSentryEvent } from './src/lib/observability/phi-scrub';
import { readBuildSha, readBuildEnvironment } from './src/lib/observability/build-info';

let initialized = false;

export function initSentryClient(): boolean {
  if (initialized) return isSentryEnabled();
  initialized = true;

  const dsn = getSentryDsn();
  if (!dsn) {
    if (isProductionLikeEnv()) {
      console.warn('[sentry] VITE_SENTRY_DSN ausente en entorno productivo — errores no se reportan a Sentry.');
    }
    return false;
  }

  const environment = getSentryEnvironment() || readBuildEnvironment() || 'development';
  const prodLike = isProductionLikeEnv();
  const release = getSentryRelease() || (readBuildSha() ? `clinical@${readBuildSha()}` : undefined);

  Sentry.init({
    dsn,
    environment,
    release,
    enabled: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: prodLike ? 0.15 : 1.0,
    replaysSessionSampleRate: prodLike ? 0.05 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    beforeSend(event) {
      return scrubSentryEvent(event);
    },
  });

  return true;
}

export { Sentry };
